import React, { Component } from 'react';
import { Input, Modal, Button, Tabs, Row, Col, Dropdown, Icon, Menu, Collapse, Form, Select, Radio, DatePicker, Checkbox } from 'antd';

import './profile.css';
import Skeleton from 'react-loading-skeleton';
import moment from 'moment';
const Panel = Collapse.Panel;
const { TextArea } = Input;


// for check box
// function onChange(checkedValues) {
//     console.log('checked = ', checkedValues);
//   }


class ContactInfo extends Component {

    state = {
        // value: "type here!",
        isInEditMode: false
    }

    changeEditMode = () => {
        this.setState({
            isInEditMode: !this.state.isInEditMode
        })
    }

    updateComponentValue = () => {
        this.setState({
            isInEditMode: false,
            // value: this.refs.theTextInput.value
        })
    }

    renderEditView = () => {
        const Option = Select.Option;
        const FormItem = Form.Item;
        const dateFormat = 'MM/DD/YYYY';

        return (<div className='container'>
            <Collapse defaultActiveKey={['1']} accordion bordered={false} >
                <Panel key="1" header={<div> <span className="myProfile-collapse-header"> Contact Information</span> <span style={{ fontSize: '12px', color: 'grey', fontWeight: 300, marginLeft: '14px' }}>Edting...</span> </div>}>
                    <Form className='myprofile-form' style={{ display: 'block' }}>
                        <p className='widget-content-section'>
                            <Row type='flex' justify='space-between'>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label="  Phone "
                                    >
                                        <Input placeholder="  Phone " />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label=" Cell Phone"
                                    >
                                        <Input placeholder=" Cell Phone" />
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row type='flex' justify='space-between'>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label=" Email"
                                    >
                                        <Input placeholder=" Email" type="e-mail" />
                                        <span style={{ float: 'right', lineHeight: '24px' }}>Confirmation of transaction will be sent to this email address</span>
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label="Business Phone"
                                    >
                                        <Input placeholder="Business Phone" />
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row type='flex' justify='space-between'>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label="Spouse/Partner First Name"
                                    >
                                        <Input placeholder="Spouse/Partner First Name" />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label="Spouse/Partner Last Name"
                                    >
                                        <Input placeholder="Spouse/Partner Last Name" />
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row type='flex' justify='space-between'>
                                <FormItem
                                    label="Other Email Preferences"
                                >
                                    <Checkbox.Group style={{ width: '100%' }}
                                    // onChange={onChange}
                                    >
                                        <Row type='flex' justify='space-between'>
                                            <Col xs={22} sm={22} md={11} lg={11} xl={11}><Checkbox value="A">Do not want to support the Scouting America financially</Checkbox></Col>
                                            <Col xs={22} sm={22} md={11} lg={11} xl={11}><Checkbox value="B">Do not want to affiliate with the Scouting America</Checkbox></Col>
                                            <Col xs={22} sm={22} md={11} lg={11} xl={11}><Checkbox value="C">Do not want bi-monthly Scouting Alumni Latest News Updates</Checkbox></Col>
                                            <Col xs={22} sm={22} md={11} lg={11} xl={11}><Checkbox value="D">
                                                Please do not make me aware of discounts and deals from businesses that are available to Scouting alumni Deceased</Checkbox></Col>
                                        </Row>
                                    </Checkbox.Group>
                                </FormItem>
                            </Row>
                            <hr className="line-divider-full" />
                            <Row type='flex' justify='space-around'>
                                <Col xs={23} sm={23} md={18} lg={18} xl={18}>
                                    <Row type='flex' justify='space-around'>
                                        <Col xs={22} sm={22} md={9} lg={9} xl={9}>
                                            <Button id="ap-cn-cl" className="myprofile-cancel-btn" onClick={this.changeEditMode}>Cancel</Button>
                                        </Col>
                                        <Col xs={22} sm={22} md={9} lg={9} xl={9}>
                                            <Button id="ap-cn-sub" className="save-change-btn" onClick={this.updateComponentValue} type="primary">SAVE CHANGE</Button>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </p>
                    </Form>
                </Panel>
            </Collapse>
        </div>

        )
    }

    renderDefaultView = () => {
        return (
            <div className='container'>
                <Collapse bordered={false} >
                    <Panel header={<div className="alumni-header"> <span className="myProfile-collapse-header"> Contact Information</span>
                        <span className="editing-btn"><i class="fa fa-pencil" onClick={this.changeEditMode}></i></span>
                    </div>}>
                        <p className='widget-content-section'>
                            <Row type='flex' justify='space-between'>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'> Phone </label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'> Cell Phone</label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'> Email</label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                {/* </Row>
                            <Row> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'>Business Phone </label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'>Spouse/Partner First Name </label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'>Spouse/Partner Last Name </label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'>Other Email Preferences </label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                            </Row>
                        </p>
                    </Panel>
                </Collapse>
            </div>
        )
    }


    render() {

        return this.state.isInEditMode ?
            this.renderEditView() :
            this.renderDefaultView()
    }
}

export default ContactInfo;


// WEBPACK FOOTER //
// ./src/components/AlumniProfile/ContactInformation.js